import { Badge, IconNames } from '@dixa/lib-shared-habla';
import { AiDraftType } from 'lib-knowledge-management-common/graphql';

/** Also the preview's labels, which name the same draft without an icon. */
export const TYPE_LABEL: Record<AiDraftType, string> = {
  [AiDraftType.NewArticle]: 'New article',
  [AiDraftType.ArticleUpdate]: 'Article update',
};

const TYPE_ICON: Record<AiDraftType, IconNames> = {
  [AiDraftType.NewArticle]: 'plus',
  [AiDraftType.ArticleUpdate]: 'pen',
};

/**
 * Which kind of draft a row holds. The queue lists both kinds in one list
 * ordered by date, so this is the only thing distinguishing them.
 */
export function SuggestionTypeBadge({
  type,
}: {
  type: AiDraftType;
}): JSX.Element {
  return (
    <Badge variant="primary" size="small" icon={TYPE_ICON[type]}>
      {TYPE_LABEL[type]}
    </Badge>
  );
}
